import { api } from './config';

export interface TelegramStatus {
  enabled: boolean;
  mode: 'webhook' | 'polling' | 'disabled';
  webhookEndpoint: string;
}

export interface WebhookSetupResponse {
  success: boolean;
  response: string;
}

export const telegramApi = {
  /**
   * Get Telegram bot status
   */
  getStatus: () => api.get<TelegramStatus>('/telegram/status'),

  /**
   * Setup webhook URL
   */
  setupWebhook: (webhookUrl: string) => 
    api.post<WebhookSetupResponse>('/telegram/setup-webhook', null, {
      params: { webhookUrl }
    }),

  /**
   * Remove webhook (switch back to polling mode)
   */
  removeWebhook: () => 
    api.post<WebhookSetupResponse>('/telegram/remove-webhook'),
};
